import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=5651b698&"
import script from "./CommonLayout.vue?vue&type=script&lang=js&"
export * from "./CommonLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports